module.exports = __webpack_public_path__ + "img/drawFade1.a9635d54.png";